import { URL } from "../../api/Api";
import { VENDOR_PARTNER } from "../Action";
import { catchError, DELETE, GET, getToken, POST, PUT } from "../axios/Axios";

export const VendorAddCall = (payload) => {
  return async (dispatch) => {
    try {
      const response = await POST(`${URL}/customers/partner/`, payload, {});
      dispatch({ type: VENDOR_PARTNER.vendorAddCall, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const VendorUpdateCall = async (id, payload) => {
  try {
    const response = await PUT(`${URL}/customers/partner/${id}`, payload);
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const VendorGetCall = async (id) => {
  try {
    const response = await GET(`${URL}/customers/partner/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const VendorTableGetCall = async () => {
  try {
    const response = await GET(`${URL}/customers/partner/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const VendorDelete = async (id) => {
  try {
    const response = await DELETE(`${URL}/customers/partner/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

//CRM
export const CreateNewRelationshipCall = async (type, payload) => {
  try {
    const response = await POST(`${URL}/customers/${type}/`, payload);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const UpdateeNewRelationshipCall = async (type, id, payload) => {
  try {
    const response = await PUT(`${URL}/customers/${type}/${id}`, payload);
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMNoteGet = async (type, job_id) => {
  try {
    const response = await GET(`${URL}/customers/${type}/notes/${job_id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMNoteAdd = async (type, id, payload) => {
  try {
    const response = await POST(
      `${URL}/customers/${type}/notes/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMNoteAddUpdate = async (type, id, payload) => {
  try {
    const response = await PUT(`${URL}/customers/${type}/notes/${id}`, payload);
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMNoteDelete = async (type, id) => {
  try {
    const response = await DELETE(`${URL}/customers/${type}/notes/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMAttachementCreateCall = async (type, id, payload) => {
  try {
    const response = await POST(
      `${URL}/customers/${type}/attachments/${id}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMAttachementTableGetCall = async (type, id) => {
  try {
    const response = await GET(
      `${URL}/customers/${type}/attachments/${id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMAttachementDelete = async (type, id) => {
  try {
    const response = await DELETE(
      `${URL}/customers/${type}/attachments/${id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CRMAttachementDownload = async (type, id) => {
  try {
    const token = await getToken();
    const response = await fetch(
      `${URL}/customers/${type}/attachments/download/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};
